import React, {useEffect, useState} from "react";
import 'react-calendar/dist/Calendar.css';
import {ButtonGroup, Card, CardBody, Col, Row} from "reactstrap";
import IconButton from '@mui/material/IconButton';
import {NavLink} from "react-router-dom";
import Tooltip from '@mui/joy/Tooltip';
import { Button, Typography } from '@material-ui/core';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { LineChart } from '@mui/x-charts/LineChart';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Avatar from "@mui/material/Avatar";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import EqualizerOutlinedIcon from '@mui/icons-material/EqualizerOutlined';
import PropTypes from "prop-types";
import {useTheme} from "@mui/material/styles";
import Box from "@mui/material/Box";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment-jalali";
import { Line,defaults  } from 'react-chartjs-2';



defaults.font.family = 'IranSans' // to set defult font chart to IranSans

const cardStyle={
	borderRadius:'25px',
	padding:'10px',
}

function TablePaginationActions(props) {
	const theme = useTheme();
	const { count, page, rowsPerPage, onPageChange } = props;

	const handleFirstPageButtonClick = (event) => {
		onPageChange(event, 0);
	};

	const handleBackButtonClick = (event) => {
		onPageChange(event, page - 1);
	};

	const handleNextButtonClick = (event) => {
		onPageChange(event, page + 1);
	};

	const handleLastPageButtonClick = (event) => {
		onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
	};

	return (
		<Box sx={{ flexShrink: 0, ml: 2.5 }}>
			<IconButton
				onClick={handleFirstPageButtonClick}
				disabled={page === 0}
				aria-label="first page"
			>
				{theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
			</IconButton>
			<IconButton
				onClick={handleBackButtonClick}
				disabled={page === 0}
				aria-label="previous page"
			>
				{theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
			</IconButton>
			<IconButton
				onClick={handleNextButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="next page"
			>
				{theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
			</IconButton>
			<IconButton
				onClick={handleLastPageButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="last page"
			>
				{theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
			</IconButton>
		</Box>
	);
}

TablePaginationActions.propTypes = {
	count: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	page: PropTypes.number.isRequired,
	rowsPerPage: PropTypes.number.isRequired,
};

function PatientInfo(props) {

	const [patientID, setPatientID] = useState(Cookies.get('patientID'));

	const [refreshPage, setRefreshPage] = useState(false);

	const [chartData, setChartData] = useState([]);

	const [firstName, setFirstName] = useState();
	const [lastName, setLastName] = useState();
	const [injuryType, setInjuryType] = useState();

	//api request for info
	useEffect(() => {
		Cookies.set('sessionID','-1')
		console.log('patientID',patientID)

		// Fetch personal information from an API endpoint
		axios.get(`https://back.actelmon.ir/api/doctor/patient/${patientID}`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				console.log(response.data)
				setPatientID(response.data.id)
				setFirstName(response.data.name)
				setLastName(response.data.last_name)
				setImagePreview(response.data.photo)
				setInjuryType(response.data.injury_type)
			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			});
	}, []);

	//api request for info for chart
	useEffect(() => {
		// Fetch personal information from an API endpoint
		//https://back.actelmon.ir/api/doctor/patient/detail/{Patient_id}/reports/{number_of_sessions}/
		axios.get(`https://back.actelmon.ir/api/doctor/patient/detail/${patientID}/reports/50/`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				// Apply convertToSolarAndPersian function to each item's session_date
				const updatedChartData = response.data.map(item => ({
					...item,
					session_date: convertToSolarAndPersian(item.session_date)
				}));
				setChartData(updatedChartData)
			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			});
	}, []);

	//api request for info
	useEffect(() => {
		// Fetch the sessions
		axios.get(`https://back.actelmon.ir/api/doctor/patient/sessions/${patientID}`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				console.log(response.data)
				setData(response.data)
			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			});
	}, []);

	function convertToPersianDigits(number) {
		const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

		return String(number).replace(/\d/g, (digit) => persianDigits[digit]);
	}
	const englishToPersianNumbers = (input) => {
		console.log('input',input)
		if (typeof input !== 'string' && !(input instanceof Date)) {
			console.error('Input must be a string or a Date object');
			return input;
		}

		// Define a mapping of English digits to Persian digits
		const digitMap = {
			'0': '۰',
			'1': '۱',
			'2': '۲',
			'3': '۳',
			'4': '۴',
			'5': '۵',
			'6': '۶',
			'7': '۷',
			'8': '۸',
			'9': '۹',
		};

		// Convert numbers in the input to Persian numbers
		const convertedString = input.toString().replace(/\d/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToSolarAndPersian = (gregorianDate) => {
		console.log('gregorianDate',gregorianDate)
		// Convert Gregorian date to Jalali (Solar) date
		try{
			if (!gregorianDate) gregorianDate = '2111-11-11'
			const solarDate = moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');

			// Convert English numbers to Persian numbers
			const persianNumbers = englishToPersianNumbers(solarDate)
			//const persianNumbers = Persian(solarDate.toString()).englishNumber().persianNumber()._str;
			return persianNumbers;
		}catch (e) {
			console.log(e)
		}
		return gregorianDate;

	};

	const handleConfirm = () => {
		// send the new information to the server
		console.log('conf')
	};

	const [selectedFile, setSelectedFile] = useState(null);
	const [imagePreview, setImagePreview] = useState();

	const handleFileChange = (e) => {
		const file = e.target.files[0];

		if (file && file.type.startsWith('image/')) {
			setSelectedFile(file);
			const reader = new FileReader();

			reader.onload = (e) => {
				setImagePreview(e.target.result);
			};

			reader.readAsDataURL(file);
		} else {
			setSelectedFile(null);
			setImagePreview(null);
			alert('Please select a valid image file.');
		}
	};

	// for changing between tabs
	const [value, setValue] = useState(0);
	const handleTabChange = (event, newValue) => {setValue(newValue);};

	const rows = [
		{ id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
		{ id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
		{ id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
		{ id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
		{ id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
		{ id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
		{ id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
		{ id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
		{ id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
	];

	const [painLevels, setPainLevels] = useState([]);
	const [hardnessPresent, setHardnessPresent] = useState([]);
	const [score, setScore] = useState([]);
	const [time, setTime] = useState([]);
	useEffect(() => {
		var entry = null

		// Update painLevels whenever dataList changes
		const extractedPainLevels = chartData
			.filter(entry => entry.session_date !== '0000-00-00')
			.map(entry => entry.pain_level * 100);
		setPainLevels(extractedPainLevels);

		// Update hardnessPresent whenever dataList changes
		const extractedHardnessPresent = chartData
			.filter(entry => entry.session_date !== '0000-00-00')
			.map(entry => entry.hardness_present * 100);
		setHardnessPresent(extractedHardnessPresent);

		// score
		const score = chartData
			.filter(entry => entry.session_date !== '0000-00-00')
			.map(entry =>(((entry.repeats + (1-entry.hardness_present) + (1-entry.pain_level)) / 3)*100).toFixed(0))
		setScore(score);

		// Update date whenever dataList changes
		const extractedTimes = chartData
			.filter(entry => entry.session_date !== '0000-00-00')
			.map(entry => entry.session_date);
		setTime(extractedTimes);
	}, [chartData]);

	const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
	const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
	const xLabels = [
		'Page A',
		'Page B',
		'Page C',
		'Page D',
		'Page E',
		'Page F',
		'Page G',
	];

	const [data, setData] = useState([]);
	var count = 1
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(5);
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	function rowCount() { return count++; }

	//delete patient
	const handleIconDeletePat = (id) => {
		// Send an API request to delete the row with the given ID
		axios.delete(`https://back.actelmon.ir/api/doctor/patient/${id}/`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				// Handle success, if needed
				console.log('Successfully deleted:', response.data);

				// Remove the deleted item from the Data variable
				const deletedItemId = response.data.id;
				const updatedData = data.filter(item => item.id !== deletedItemId);
				setData(updatedData);
				window.location.href = '/rtl/dashboard'
			})
			.catch((error) => {
				console.error('Error deleting data:', error);
			});
	};

	//delete patient
	const handleIconDelete = (id) => {
		// Send an API request to delete the row with the given ID
		axios.delete(`https://back.actelmon.ir/api/doctor/sessions/${id}/`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				// Handle success, if needed
				console.log('Successfully deleted:', response.data);

				// Remove the deleted item from the Data variable
				const deletedItemId = response.data.id;
				const updatedData = data.filter(item => item.id !== deletedItemId);
				setData(updatedData);
				window.location.href = '/rtl/patientprofile'
			})
			.catch((error) => {
				console.error('Error deleting data:', error);
			});
	};

	// set chart options and datas:

	const dataChart = {
		labels: time, // Format the x-axis labels to use Persian digits
		datasets: [
			{
				label: 'درد',
				data: painLevels,
				borderColor: 'rgba(255, 99, 132, 1)', // Adjust color as needed
				borderWidth: 2,
				fill: false,
			},
			{
				label: 'سختی',
				data: hardnessPresent,
				borderColor: 'rgba(54, 162, 235, 1)', // Adjust color as needed
				borderWidth: 2,
				fill: false,
			},
			{
				label: 'امتیاز',
				data: score,
				borderColor: 'rgba(75, 192, 192, 1)', // Adjust color as needed
				borderWidth: 2,
				fill: false,
			},
		],
	};


	let options = {
		maintainAspectRatio: true,
		plugins: {

			legend: {
				display: true,
			},
			tooltips: {
				backgroundColor: "#f5f5f5",
				titleFontColor: "#333",
				bodyFontColor: "#000",
				bodySpacing: 4,
				xPadding: 12,
				mode: "nearest",
				intersect: 0,
				position: "nearest",
				callbacks: {
					label: function (value) {
						// Format the tick labels to use Persian digits
						return convertToPersianDigits(value);
					},
					data: function (value) {
						// Format the tick labels to use Persian digits
						return convertToPersianDigits(value);
					},
				}
			}},
		responsive: true,
		scales: {
			yAxes: {
				barPercentage: 1.6,
				gridLines: {
					drawBorder: false,
					color: "rgba(29,140,248,0.0)",
					zeroLineColor: "transparent",
				},
				ticks: {
					suggestedMin: 60,
					suggestedMax: 125,
					padding: 20,
					fontColor: "#9a9a9a",
					callback: function (value) {
						// Format the tick labels to use Persian digits
						return convertToPersianDigits(value);
					},
				},
			},
			xAxes: {
				barPercentage: 1.6,
				gridLines: {
					drawBorder: false,
					color: "rgba(29,140,248,0.1)",
					zeroLineColor: "transparent",
					callback: function (value) {
						// Format the tick labels to use Persian digits
						return convertToPersianDigits(value);
					},

				},
				ticks: {
					padding: 20,
					fontColor: "#9a9a9a",
				},
			},
		},
	};

	const handleCopy = (session_Id) =>{
		// Send an API request to delete the row with the given ID
		axios.post(`https://back.actelmon.ir/api/doctor/replicatesession/${session_Id}/`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				// Handle success, if needed
				console.log('Successfully deleted:', response.data);
				window.location.href = '/rtl/patientprofile'
			})
			.catch((error) => {
				console.error('Error deleting data:', error);
			});
	}

	return (
		<>
			<div className="content">
				<Row lg="12" sm="12" style={{padding:'10px',borderRadius:'10px'}}>

					<Col lg="9" sm="9" className="order-2 order-lg-1">

						<div style={{...cardStyle,backgroundColor:'white'}}>
							<Tabs value={value}
							      onChange={handleTabChange}
							      indicatorColor="primary"
							      textColor="primary"
							      sx={{marginBottom:'10px'}}
							>
								<Tab sx={{fontWeight:'bold',fontSize:'18px', marginLeft:'8'}} label="لیست جلسات" style={{fontSize:'smaller'}}/>
								<Tab sx={{fontWeight:'bold',fontSize:'18px', marginLeft:'8'}} label="گزارش جلسات" style={{fontSize:'smaller'}}/>
								<Tab disabled={true} sx={{fontWeight:'bold',fontSize:'18px', marginLeft:'8'}} label="نتیجه پرسشنامه" style={{fontSize:'smaller'}}/>
							</Tabs>

							{value === 0 && <div>
								<Card style={cardStyle}>
									<CardBody style={{ direction:'rtl',textAlign:'right'}}>
										<NavLink
											to={'/rtl/newexercise'}
											className="nav-link"
											style={{width:'fit-content'}}
										>
											<Button variant="contained"
											        style={{backgroundColor:'#138C97',color:'white',direction:'ltr'}}
											        endIcon={<ControlPointIcon sx={{color:'white',marginRight:"10px"}} />}
											>
												افزودن جلسه جدید
											</Button>
										</NavLink>

										<div style={{ height: 400, width: '100%',marginTop:'20px' }}>
											<TableContainer component={Paper} sx={{direction:'rtl'}} style={{ maxHeight: 400, overflowY: 'auto'}}>
												<Table sx={{ minWidth: 650 }} aria-label="simple table">
													<TableHead>
														<TableRow sx={{fontWeight:'bold',backgroundColor:'#F6DDE2'}}>
															<TableCell sx={{fontWeight:'bold'}} align="center" >شماره</TableCell>
															<TableCell sx={{fontWeight:'bold'}} align="center">تاریخ</TableCell>
															<TableCell sx={{fontWeight:'bold'}} align="center">وضعیت</TableCell>
															<TableCell sx={{fontWeight:'bold'}} align="center">بازدهی</TableCell>
															<TableCell sx={{fontWeight:'bold'}} align="center">پرسشنامه</TableCell>
															<TableCell sx={{fontWeight:'bold'}} align="center"></TableCell>
															<TableCell sx={{fontWeight:'bold'}} align="center"></TableCell>
														</TableRow>
													</TableHead>
													<TableBody>
														{data.map((item,index) => (
															<TableRow hover key={item.name}
															          sx={{ '&:last-child td, &:last-child th': { border: 0 }}}
															>
																<TableCell align="center"
																           onClick={() => {
																	           if(item.status === 'p'){
																		           Cookies.set('sessionID',item.id)
																		           window.location.href = '/rtl/editexercise'}}}
																>
																	{englishToPersianNumbers(rowCount().toString())}
																</TableCell>

																<TableCell align="center"
																           onClick={() => {
																	           if(item.status === 'p'){
																		           Cookies.set('sessionID',item.id)
																		           window.location.href = '/rtl/editexercise'}}}
																>
																	{convertToSolarAndPersian(item.date)}
																</TableCell>

																<TableCell align="center"
																           onClick={() => {
																	           if(item.status === 'p'){
																		           Cookies.set('sessionID',item.id)
																		           window.location.href = '/rtl/editexercise'}}}
																>
																	{item.status === 'c' ? 'انجام شده' : 'انجام نشده'}
																</TableCell>

																<TableCell align="center"
																           onClick={() => {
																	           if(item.status === 'p'){
																		           Cookies.set('sessionID',item.id)
																		           window.location.href = '/rtl/editexercise'}}}
																>
																	{englishToPersianNumbers(item.rate ? item.rate.toString() : '0')}%
																</TableCell>

																<TableCell align="center"
																           onClick={() => {
																	           if(item.status === 'p'){
																		           Cookies.set('sessionID',item.id)
																		           window.location.href = '/rtl/editexercise'}}}
																>
																	{item.qustrionary === 'false' ? 'ندارد' : 'دارد'}
																</TableCell>

																<TableCell align="center">
																	<div>
																		<ButtonGroup>
																			<Tooltip title="کپی" variant="soft" arrow>
																				<IconButton aria-label="edit" size="large"
																										onClick={() => handleCopy(item.id)}>
																					<FileCopyOutlinedIcon
																						fontSize="inherit"
																						style={{ color: '#138C97', padding: '4px' }} />
																				</IconButton>
																			</Tooltip>

																			<Tooltip title="گزارش" variant="soft" arrow
																			         disabled={item.status !== 'c'}>

																				<NavLink
																					to={item.status === 'c' ? '/rtl/sessionreport' : '#'}
																					className="nav-link"
																					style={{width:'fit-content'}}
																				>
																					<IconButton aria-label="edit"
																					            size="large"
																					            onClick={() => {
																						            Cookies.set('sessionID',item.id)
																						            Cookies.set('sessionNum',index+1)
																					            }}
																					>
																						<EqualizerOutlinedIcon
																							fontSize="inherit"
																							style={{ color: '#9AACBD', padding: '4px' }} />
																					</IconButton>
																				</NavLink>

																			</Tooltip>
																		</ButtonGroup>
																	</div>
																</TableCell>
																<TableCell align="center">
																	<div>
																		<ButtonGroup>
																			<Tooltip title="ویرایش" variant="soft" arrow>
																				<NavLink className="nav-link" onClick={() => {
																					if(item.status === 'p'){
																						Cookies.set('sessionID',item.id)
																						window.location.href = '/rtl/editexercise'
																					}
																				}}>
																					<IconButton aria-label="edit" size="large" disabled={item.status === 'c'}>
																						<BorderColorIcon
																							fontSize="inherit"
																							style={{ color: item.status === 'p' ? '#38C5AB' : 'lightgray', padding: '4px' }} />
																					</IconButton>
																				</NavLink>
																			</Tooltip>
																			<Tooltip title="حذف" variant="soft" arrow>
																				<IconButton aria-label="edit" size="large" onClick={() => handleIconDelete(item.id)}>
																					<DeleteForeverIcon
																						fontSize="inherit"
																						style={{ color: '#D0576E', padding: '4px' }} />
																				</IconButton>
																			</Tooltip>
																		</ButtonGroup>
																	</div>
																</TableCell>
															</TableRow>
														))}
													</TableBody>
												</Table>
											</TableContainer>
										</div>
									</CardBody>
								</Card>
							</div>}

							{value === 1 && <div>
								<Card style={cardStyle}>
									<CardBody style={{direction:'ltr',padding:"0px !important"}}>
										<Line data={dataChart} options={options} height={350} />
									</CardBody>
								</Card>
							</div>}

							{value === 2 && <div>
								<Card style={cardStyle} >
									<CardBody style={{direction:'ltr',padding:"0px !important"}} >
										<LineChart
											height={350}
											series={[
												{ data: pData, label: 'pv', id: 'pvId' },
												{ data: uData, label: 'uv', id: 'uvId' },
											]}
											xAxis={[{ scaleType: 'point', data: xLabels }]}
											sx={{
												'.MuiLineElement-root, .MuiMarkElement-root': {
													strokeWidth: 1,
												},
												'.MuiLineElement-series-pvId': {
													strokeDasharray: '5 5',
												},
												'.MuiLineElement-series-uvId': {
													strokeDasharray: '3 4 5 2',
												},
												'.MuiMarkElement-root:not(.MuiMarkElement-highlighted)': {
													fill: '#fff',
												},
												'& .MuiMarkElement-highlighted': {
													stroke: 'none',
												},
											}}
										/>
									</CardBody>
								</Card>
							</div>}
						</div>

					</Col>

					<Col lg="3" sm="3" className="mt-5 mt-lg-0 order-lg-2 order-1">

						<Card style={cardStyle} >
							<CardBody>
								<Tooltip title="ویرایش" variant="soft">
									<IconButton aria-label="edit" size="large" onClick={() => props.edit(true)}>
										<EditNoteIcon fontSize="inherit" sx={{color:"#138C97"}} />
									</IconButton>
								</Tooltip>
								<div className="logo"
								     style={{
											 width: '100%',
									     display: 'flex',
									     flexDirection: 'column',
									     alignItems: 'center',
									     textAlign: 'center'
								}}>
									<Avatar
										alt={firstName}
										src={imagePreview}
										sx={{
											width: 140,
											height: 140,
											backgroundColor: 'primary.main',
											margin: '0 auto',
											marginBottom: 2,
											marginTop: 2,
										}}
									/>
									<Typography variant="h5" component="div" sx={{ color:'#D0576E', fontWeight:'bold' }}>
										{firstName} {lastName}
									</Typography>

									<div style={{margin:'5px'}}>

									</div>

									<Button
										variant="outlined"
										fullWidth={true}
										style={{backgroundColor:'rgba(56,197,171,0)', border: '5px solid rgba(56,197,171,0.58)', borderRadius:'10px' ,margin:'10px'}}
										disableRipple
									>
										نوع آسیب: {injuryType}
									</Button>

									<Button
										variant="outlined"
										fullWidth={true}
										style={{backgroundColor:'rgba(56,197,171,0.58)' ,margin:'10px'}}
										onClick={() => props.viewInfo(true)}
									>
										اطلاعات شخصی بیمار
									</Button>
									<Button
										variant="outlined"
										fullWidth={true}
										startIcon={<LocalPhoneIcon sx={{marginLeft:'10px'}}/>}
										style={{backgroundColor:'rgba(56,197,171,0.58)' ,margin:'10px'}}
									>
										تماس با بیمار
									</Button>
									<Button
										variant="outlined"
										fullWidth={true}
										startIcon={<DeleteForeverIcon sx={{marginLeft:'10px' , color:'white'}}/>}
										style={{backgroundColor:'rgba(217,120,138,0.56)',color:'white' ,margin:'10px'}}
										onClick={() => handleIconDeletePat(Cookies.get('patientID'))}
									>
										حذف بیمار
									</Button>

								</div>

							</CardBody>
						</Card>

					</Col>

				</Row>
			</div>
		</>
	);
}

export default PatientInfo;
